/*
  ISLI STUDIO — Filtre de sous-collections, sans rechargement.

  FICHIER NEUF. Aucun fichier coeur du theme n'est modifie.

  Trois collections reelles : Earrings, et ses deux sous-ensembles Boldy et
  Sunny Hoops. Cliquer sur l'une d'elles ne doit PAS naviguer : seule la grille
  de produits change, le reste de la page ne bouge pas.

  ⚠️ POURQUOI L'API DE RENDU DE SECTION PLUTOT QU'UN FILTRAGE DANS LE NAVIGATEUR.
  Filtrer les cartes deja presentes serait plus rapide a ecrire, mais faux : la
  grille est paginee, et les produits d'une sous-collection absents de la
  premiere page ne seraient jamais affiches. On demande donc a Shopify de rendre
  la SECTION de grille pour la collection visee, et on remplace le contenu.
  Les trois collections partagent le meme gabarit, donc le meme identifiant de
  section : le HTML recu se substitue exactement a celui en place.

  ⚠️ CE QUI N'EST VOLONTAIREMENT PAS MIS A JOUR : la banniere et le titre. La
  demande est explicite, seuls les produits changent. Le titre reste « Earrings »
  parce que Boldy et Sunny Hoops SONT des boucles d'oreilles : la page ne change
  pas de sujet, elle se resserre.

  L'adresse, elle, est reecrite par `pushState`. Un rechargement, un partage ou
  un retour arriere retombent donc sur une vraie page de collection, rendue par
  le serveur. Le referencement garde ses trois URL.
*/

(() => {
  const SELECTEUR_NAV = '[data-isli-subfiltre]';
  const SELECTEUR_LIEN = '[data-isli-subfiltre-lien]';
  const CLASSE_COURANT = 'isli-subfilter__link--current';

  const nav = document.querySelector(SELECTEUR_NAV);
  if (!nav) return;

  // La grille vit dans la section `collection_main` du gabarit. On la retrouve
  // par son suffixe plutot que par un identifiant en dur : celui-ci contient
  // l'identifiant du theme, qui change a chaque duplication.
  const grille = document.querySelector('[id^="shopify-section-"][id$="__collection_main"]');
  if (!grille) return;

  const idSection = grille.id.replace('shopify-section-', '');

  // Les pages deja recues sont gardees : revenir sur « All » apres un aller-retour
  // doit etre instantane, et la grille n'a pas change entre-temps.
  const cache = new Map();

  let requeteEnCours = null;

  const marquerCourant = (chemin) => {
    nav.querySelectorAll(SELECTEUR_LIEN).forEach((lien) => {
      const actif = new URL(lien.href, location.origin).pathname === chemin;
      lien.classList.toggle(CLASSE_COURANT, actif);
      if (actif) {
        lien.setAttribute('aria-current', 'page');
      } else {
        lien.removeAttribute('aria-current');
      }
    });
  };

  const recuperer = async (chemin) => {
    if (cache.has(chemin)) return cache.get(chemin);

    const url = new URL(chemin, location.origin);
    url.searchParams.set('section_id', idSection);

    const reponse = await fetch(url.toString(), { headers: { 'X-Requested-With': 'fetch' } });
    if (!reponse.ok) throw new Error('rendu de section indisponible : ' + reponse.status);

    const html = await reponse.text();
    cache.set(chemin, html);
    return html;
  };

  const appliquer = (html) => {
    // On extrait le contenu de la section recue. Le fragment renvoye est
    // enveloppe dans le meme <section id="shopify-section-…"> que celui en
    // place : c'est son INTERIEUR que l'on transplante, pour ne pas detruire
    // l'element auquel le theme a pu s'accrocher.
    const bac = document.createElement('div');
    bac.innerHTML = html;
    const recue = bac.querySelector('#' + CSS.escape(grille.id)) || bac.firstElementChild;
    if (!recue) return;

    grille.innerHTML = recue.innerHTML;

    // Les composants du theme sont des elements personnalises : ils se
    // reveillent d'eux-memes a l'insertion dans le document. Rien a relancer.
  };

  const aller = async (chemin, { historique }) => {
    if (new URL(location.href).pathname === chemin && !historique) return;

    // Une navigation rapide entre trois onglets peut faire arriver les reponses
    // dans le desordre. On ne retient que la derniere demandee.
    const jeton = {};
    requeteEnCours = jeton;

    grille.setAttribute('aria-busy', 'true');
    marquerCourant(chemin);

    try {
      const html = await recuperer(chemin);
      if (requeteEnCours !== jeton) return;
      appliquer(html);
      if (!historique) history.pushState({ isliSubfiltre: chemin }, '', chemin);
    } catch (erreur) {
      // En cas d'echec on ne laisse pas l'utilisateur devant une grille figee :
      // la navigation normale prend le relais.
      if (requeteEnCours === jeton) location.assign(chemin);
    } finally {
      if (requeteEnCours === jeton) grille.removeAttribute('aria-busy');
    }
  };

  nav.addEventListener('click', (evenement) => {
    const lien = evenement.target.closest(SELECTEUR_LIEN);
    if (!lien || !nav.contains(lien)) return;

    // On laisse passer tout ce qui n'est pas un clic gauche simple : ouvrir dans
    // un nouvel onglet doit rester possible.
    if (evenement.defaultPrevented) return;
    if (evenement.button !== 0 || evenement.metaKey || evenement.ctrlKey || evenement.shiftKey || evenement.altKey) return;

    const cible = new URL(lien.href, location.origin);
    if (cible.origin !== location.origin) return;

    evenement.preventDefault();
    aller(cible.pathname, { historique: false });
  });

  // Retour et suivant du navigateur : l'adresse change sans rechargement, il
  // faut donc remettre la grille en accord avec elle.
  window.addEventListener('popstate', () => {
    aller(location.pathname, { historique: true });
  });
})();
